/**
 * The chest stage's clock (chestStage.ts): real seconds in, scene seconds out, so the burst can drop into slow motion —
 * a quarter speed as the lid is thrown, easing back to full speed over ~0.4 s — while the flight and the camera's turn
 * keep real time. Pure, so the curve is tested (test/uiPhase2.test.ts).
 */
export class StageClock {
  /** Real seconds since the stage started. */
  now = 0;
  private slowT = -1;
  /** The slow motion: held at `Floor` for `HoldS`, back to 1 over `EaseS`. */
  static readonly Floor = 0.25;
  static readonly HoldS = 0.32;
  static readonly EaseS = 0.4;
  /** The effects (sparks, flashes, rings) slow less: at a quarter speed the burst's flash would hang over the chest for a second. */
  static readonly VfxFloor = 0.6;

  /** Starts the slow motion (the burst). */
  slowMo(): void { this.slowT = 0; }
  /** Ends it (a skip). */
  reset(): void { this.slowT = -1; }

  /** The scene's time scale now: 1 outside the slow motion. */
  get scale(): number {
    const t = this.slowT;
    if (t < 0) return 1;
    if (t < StageClock.HoldS) return StageClock.Floor;
    const u = Math.min(1, (t - StageClock.HoldS) / StageClock.EaseS);
    return StageClock.Floor + (1 - StageClock.Floor) * u * u * (3 - 2 * u);
  }

  /** Advances by `real` seconds; returns the scene's seconds for this frame. */
  tick(real: number): number {
    this.now += real;
    const dt = real * this.scale;
    if (this.slowT >= 0) { this.slowT += real; if (this.slowT > StageClock.HoldS + StageClock.EaseS) this.slowT = -1; }
    return dt;
  }
}
